import cjPontanegraApi from '../apis/cjPontanegraApi';

export const deleteUserAvatarsService = async (
  userId: string,
): Promise<void> => {
  await cjPontanegraApi.delete(`/avatars/users/${userId}`);
};
